import { render, staticRenderFns } from "./createAssessment.vue?vue&type=template&id=3342646f"
import script from "./createAssessment.vue?vue&type=script&lang=js"
export * from "./createAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports